import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { from, of, switchMap, map } from 'rxjs';

async function decompressBase64Gzip(base64Data: string): Promise<any> {
  const binaryString = atob(base64Data);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const ds = new (window as any).DecompressionStream('gzip');
  const writer = ds.writable.getWriter();
  writer.write(bytes);
  writer.close();

  const reader = ds.readable.getReader();
  const chunks: Uint8Array[] = [];
  let done = false;
  while (!done) {
    const result = await reader.read();
    done = result.done;
    if (result.value) {
      chunks.push(result.value);
    }
  }

  const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
  const combined = new Uint8Array(totalLength);
  let offset = 0;
  for (const chunk of chunks) {
    combined.set(chunk, offset);
    offset += chunk.length;
  }

  const text = new TextDecoder().decode(combined);
  return JSON.parse(text);
}

export const decompressInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    switchMap(event => {
      const body = event instanceof HttpResponse ? event.body as any : null;
      if (
        body &&
        body.isBase64Encoded === true &&
        typeof body.body === 'string'
      ) {
        return from(decompressBase64Gzip(body.body)).pipe(
          map(decompressedBody => (event as HttpResponse<unknown>).clone({ body: decompressedBody }))
        );
      }
      return of(event);
    })
  );
};
